import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-idex-winners',
  standalone: false,
  templateUrl: './idex-winners.component.html',
})
export class IdexWinnersComponent implements OnInit, OnDestroy {
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;

  @Input() step: any;
  @Input() data: any[] = [];
  @Input() proposalName: any;
  @Input() proposalId: any;
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  Winnercols = [
    { field: 'vendor.name', header: 'Vendor Name', filterType: 'text', width: '200px', minWidth: '100px', maxWidth: '150px' },
    { field: 'vendor.address', header: 'Vendor Address', filterType: 'text', width: '200px', minWidth: '100px', maxWidth: '150px' },
    { field: 'vendor.contact', header: 'Contract Persion', filterType: 'text',  width: '200px', minWidth: '100px', maxWidth: '150px' },
    { field: 'vendor_status', header: 'Status', filterType: 'status', width: '200px', minWidth: '100px', maxWidth: '150px' },
    // { field: 'vendor.email', header: 'Contact Email', filterType: 'text' }
  ];
  winner:any
  userID: any;
  private subscriptions = new Subscription();
   constructor(private messageService: MessageService,  private api: ApiService,) { }
  ngOnInit(): void {
    this.updateWinners()
     const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  generatePDF() {
    // Sort winners by total score in descending order and assign ranks
    const sortedWinners = this.data
      .sort((a, b) => b.total - a.total)
      .map((winner, index) => ({ ...winner, rank: index + 1 }));

    // Build winner entries to add to payload
    const winnerData = sortedWinners.map((winner, idx) => ({
      key: `Rank ${idx + 1}`,
      value: `Name: ${winner.vendor.name}`
    }));

    // Final payload with appended sorted winner data
    const payload = {
      url: '/revenue/need/version-control/',
      data: [...winnerData]
    };
    this.generatePDFEmitter.emit(payload);
  }
  totalRecords = 0
  updateWinners(event: { page: number; search?: string } = { page: 1 }) {
    const sub = this.api.getAPI(`/idex/finalize/winner/?evaluation__proposal_step__proposal=${this.proposalId}&evaluation__proposal_step=${this.step.id}`).subscribe((res: any) => {
      this.winner = res.data;
      this.totalRecords = this.winner.length
    });
    this.subscriptions.add(sub);
  }
}
